import { EN_CALENDAR, ES_CALENDAR } from "common/utils/date"
import { addLocale } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { InputText } from "primereact/inputtext"
import { useTranslation } from "react-i18next"

const DatosFacturaForm = ({
  values,
  touched,
  handleChange,
  handleBlur,
  errors,
}: $TSMigrationFixMe) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  addLocale("es", ES_CALENDAR)
  addLocale("en", EN_CALENDAR)

  return (
    <>
      <div className='text-left p-fluid p-formgrid p-grid'>
        <div className='p-field p-col'>
          <label htmlFor='numFactura'>{t("filtros.fecha.numFactLabel")}</label>

          <InputText
            id='numFactura'
            name='numero'
            className={
              errors.numero && touched.numero ? "!tw-border-danger" : ""
            }
            onBlur={handleBlur}
            value={values.numero}
            onChange={handleChange}
            type='text'
          />
          {errors.numero && touched.numero && (
            <div className='mt-1 text-danger'>
              <small>{t("errors.fieldEmpty")}</small>
            </div>
          )}
        </div>

        <div className='p-field p-col'>
          <label htmlFor='calendar-fechaFactura'>
            {t("filtros.fecha.dateEmisionLabel")}
          </label>

          <Calendar
            id='calendar-fechaFactura'
            // @ts-expect-error TS(2769): No overload matches this call.
            autoFocus
            name='fechaFactura'
            className={
              errors.fechaFactura && touched.fechaFactura
                ? "[&>:first-child]:!tw-border-danger"
                : ""
            }
            value={values.fechaFactura}
            locale={language}
            dateFormat='dd/mm/yy'
            mask='99/99/9999'
            onChange={handleChange}
            showIcon
          />

          {errors.fechaFactura && touched.fechaFactura && (
            <div className='mt-1 text-danger'>
              <small>{t("filtros.fecha.emptyMsg")}</small>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default DatosFacturaForm
